// Đường dẫn đang mở → id trang trong kho hướng dẫn.
//
// Bảng tra dựng TỪ NAV_GROUPS chứ không chép tay: menu đổi đường dẫn mà bảng
// chép tay đứng yên thì nút hướng dẫn im lặng biến mất, không ai biết.
//
// Vài mục dùng chung một đường dẫn, phân biệt bằng thẻ (`?tab=`): /retouch có
// "Sửa hình" và "Đơn in"; /cskh có năm thẻ. Vì thế phải tra bằng cả đường dẫn
// lẫn thẻ, tra mỗi đường dẫn là năm mục CSKH dồn về một bài.

import { NAV_GROUPS } from "@/components/sidebar/nav-items";

type Entry = { id: string; tab?: string | undefined };

// đường dẫn → danh sách mục dùng đường dẫn đó
const BY_PATH: Map<string, Entry[]> = (() => {
  const m = new Map<string, Entry[]>();
  for (const g of NAV_GROUPS) {
    for (const item of g.items) {
      const push = (path: string, e: Entry) => {
        const list = m.get(path);
        if (list) list.push(e);
        else m.set(path, [e]);
      };
      push(item.to, { id: item.id, tab: item.search?.tab });
      for (const alt of item.alt ?? []) push(alt.to, { id: alt.id });
    }
  }
  return m;
})();

/**
 * Id trang cho hướng dẫn, hoặc null khi đường dẫn không thuộc menu.
 *
 * `tab` là giá trị `?tab=` đang mở (nếu trang có thẻ).
 */
export function resolveGuideId(pathname: string, tab?: string | null): string | null {
  // Bỏ dấu / thừa ở cuối để "/orders/" và "/orders" ra cùng một mục.
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  const entries = BY_PATH.get(path);
  if (!entries || entries.length === 0) return null;
  const first = entries[0];
  if (!first) return null;
  if (entries.length === 1) return first.id;

  // Nhiều mục chung đường dẫn: khớp đúng thẻ đang mở.
  const byTab = tab ? entries.find((e) => e.tab === tab) : undefined;
  if (byTab) return byTab.id;

  // Chưa có thẻ trên thanh địa chỉ (vừa vào trang, thẻ mặc định chưa ghi vào
  // đường dẫn) → lấy mục KHÔNG kèm thẻ nếu có, không thì mục đầu tiên.
  return (entries.find((e) => !e.tab) ?? first).id;
}
